// Nomad Compass Index — Q1 2026
// 41 countries scored across 8 dimensions (0-100).
// Source: Nomad Compass Index methodology paper Q1 2026.

export const INDEX_COUNTRIES = [
  { name: 'Portugal', region: 'Europe \u00b7 D8', access: 82, speed: 70, cost: 78, tax: 94, family: 88, perm: 95, stable: 85, life: 90 },
  { name: 'Spain', region: 'Europe \u00b7 DNV', access: 80, speed: 78, cost: 75, tax: 88, family: 84, perm: 90, stable: 82, life: 88 },
  { name: 'United Arab Emirates', region: 'Middle East \u00b7 VWP', access: 86, speed: 92, cost: 58, tax: 100, family: 72, perm: 45, stable: 88, life: 82 },
  { name: 'Estonia', region: 'Europe \u00b7 DNV', access: 78, speed: 85, cost: 82, tax: 78, family: 68, perm: 82, stable: 90, life: 80 },
  { name: 'Italy', region: 'Europe \u00b7 DNV', access: 70, speed: 65, cost: 72, tax: 80, family: 85, perm: 88, stable: 75, life: 92 },
  { name: 'Croatia', region: 'Europe \u00b7 DNR', access: 88, speed: 75, cost: 88, tax: 82, family: 70, perm: 70, stable: 78, life: 82 },
  { name: 'Japan', region: 'Asia \u00b7 DNV', access: 55, speed: 70, cost: 60, tax: 65, family: 75, perm: 55, stable: 85, life: 95 },
  { name: 'Mauritius', region: 'Indian Ocean \u00b7 PTV', access: 90, speed: 80, cost: 85, tax: 82, family: 72, perm: 65, stable: 72, life: 75 },
  { name: 'Costa Rica', region: 'Americas \u00b7 Rentista', access: 82, speed: 70, cost: 78, tax: 65, family: 82, perm: 80, stable: 70, life: 82 },
  { name: 'Barbados', region: 'Caribbean \u00b7 Welcome Stamp', access: 72, speed: 88, cost: 55, tax: 78, family: 75, perm: 60, stable: 82, life: 88 },
  { name: 'Thailand', region: 'Asia \u00b7 DTV', access: 82, speed: 78, cost: 85, tax: 70, family: 72, perm: 55, stable: 68, life: 82 },
  { name: 'Malta', region: 'Europe \u00b7 Nomad Residence', access: 75, speed: 72, cost: 65, tax: 80, family: 78, perm: 75, stable: 82, life: 85 },
  { name: 'Greece', region: 'Europe \u00b7 DN Visa', access: 78, speed: 68, cost: 82, tax: 75, family: 78, perm: 80, stable: 72, life: 85 },
  { name: 'Mexico', region: 'Americas \u00b7 Temporary Resident', access: 78, speed: 72, cost: 80, tax: 62, family: 78, perm: 85, stable: 65, life: 78 },
  { name: 'Argentina', region: 'Americas \u00b7 DNV', access: 85, speed: 62, cost: 72, tax: 58, family: 75, perm: 78, stable: 45, life: 75 },
  { name: 'Georgia', region: 'Europe/Asia \u00b7 Remotely', access: 95, speed: 88, cost: 92, tax: 88, family: 62, perm: 72, stable: 62, life: 68 },
  { name: 'Brazil', region: 'Americas \u00b7 DNV', access: 78, speed: 65, cost: 78, tax: 60, family: 80, perm: 82, stable: 60, life: 78 },
  { name: 'Colombia', region: 'Americas \u00b7 DNV', access: 88, speed: 72, cost: 85, tax: 65, family: 72, perm: 78, stable: 62, life: 72 },
  { name: 'Panama', region: 'Americas \u00b7 Remote Worker', access: 72, speed: 80, cost: 68, tax: 85, family: 70, perm: 80, stable: 75, life: 75 },
  { name: 'Uruguay', region: 'Americas \u00b7 DNV', access: 75, speed: 70, cost: 72, tax: 82, family: 80, perm: 82, stable: 82, life: 80 },
  { name: 'Cyprus', region: 'Europe \u00b7 DN Visa', access: 78, speed: 72, cost: 68, tax: 85, family: 82, perm: 78, stable: 78, life: 82 },
  { name: 'Iceland', region: 'Europe \u00b7 Long-term Remote', access: 55, speed: 70, cost: 50, tax: 68, family: 78, perm: 60, stable: 92, life: 92 },
  { name: 'Hungary', region: 'Europe \u00b7 White Card', access: 78, speed: 70, cost: 78, tax: 72, family: 72, perm: 65, stable: 70, life: 75 },
  { name: 'Romania', region: 'Europe \u00b7 DNV', access: 82, speed: 68, cost: 88, tax: 78, family: 70, perm: 72, stable: 68, life: 72 },
  { name: 'Czech Republic', region: 'Europe \u00b7 Zivno', access: 68, speed: 72, cost: 75, tax: 72, family: 75, perm: 75, stable: 82, life: 82 },
  { name: 'Latvia', region: 'Europe \u00b7 DNV', access: 78, speed: 72, cost: 82, tax: 72, family: 68, perm: 72, stable: 78, life: 75 },
  { name: 'Ecuador', region: 'Americas \u00b7 DNV', access: 85, speed: 62, cost: 88, tax: 68, family: 70, perm: 78, stable: 55, life: 68 },
  { name: 'Peru', region: 'Americas \u00b7 DNV', access: 82, speed: 65, cost: 85, tax: 65, family: 68, perm: 72, stable: 55, life: 68 },
  { name: 'Armenia', region: 'Asia \u00b7 DNV', access: 92, speed: 72, cost: 92, tax: 80, family: 62, perm: 68, stable: 58, life: 62 },
  { name: 'Albania', region: 'Europe \u00b7 Unique Permit', access: 92, speed: 68, cost: 90, tax: 75, family: 62, perm: 60, stable: 55, life: 62 },
  { name: 'Montenegro', region: 'Europe \u00b7 DN Programme', access: 80, speed: 70, cost: 85, tax: 78, family: 65, perm: 62, stable: 62, life: 72 },
  { name: 'Namibia', region: 'Africa \u00b7 DN Visa', access: 75, speed: 68, cost: 80, tax: 62, family: 62, perm: 55, stable: 68, life: 62 },
  { name: 'Seychelles', region: 'Africa \u00b7 Workcation', access: 68, speed: 82, cost: 60, tax: 72, family: 70, perm: 48, stable: 75, life: 82 },
  { name: 'Cape Verde', region: 'Africa \u00b7 Remote Working', access: 78, speed: 72, cost: 78, tax: 72, family: 62, perm: 55, stable: 72, life: 72 },
  { name: 'Taiwan', region: 'Asia \u00b7 Gold Card', access: 62, speed: 78, cost: 75, tax: 72, family: 75, perm: 72, stable: 78, life: 88 },
  { name: 'South Korea', region: 'Asia \u00b7 DNV', access: 62, speed: 75, cost: 68, tax: 68, family: 75, perm: 60, stable: 82, life: 88 },
  { name: 'Malaysia', region: 'Asia \u00b7 DE Rantau', access: 80, speed: 72, cost: 82, tax: 78, family: 72, perm: 60, stable: 72, life: 78 },
  { name: 'Philippines', region: 'Asia \u00b7 DN Visa', access: 85, speed: 68, cost: 88, tax: 68, family: 70, perm: 55, stable: 62, life: 68 },
  { name: 'Sri Lanka', region: 'Asia \u00b7 DNV', access: 82, speed: 62, cost: 88, tax: 62, family: 62, perm: 52, stable: 55, life: 62 },
  { name: 'Dominica', region: 'Caribbean \u00b7 Work in Nature', access: 78, speed: 78, cost: 68, tax: 82, family: 65, perm: 58, stable: 72, life: 75 },
  { name: 'Antigua & Barbuda', region: 'Caribbean \u00b7 Nomad Residence', access: 75, speed: 82, cost: 60, tax: 85, family: 68, perm: 55, stable: 75, life: 78 },
];

export const DIM_KEYS = ['access', 'speed', 'cost', 'tax', 'family', 'perm', 'stable', 'life'];

export const DEFAULT_WEIGHTS = {
  access: 15,
  speed: 10,
  cost: 15,
  tax: 15,
  family: 10,
  perm: 10,
  stable: 10,
  life: 15,
};

export const DIM_LABELS = {
  access: 'Accessibility',
  speed: 'Processing Speed',
  cost: 'Total Cost of Moving',
  tax: 'Tax Friendliness',
  family: 'Family Viability',
  perm: 'Path to Permanence',
  stable: 'Visa Stability',
  life: 'Quality of Life',
};

// Editorial Top 10 (published default ranking with movement + notes)
export const TOP10 = [
  {
    rank: 1,
    name: 'Portugal',
    region: 'Europe \u00b7 EU \u00b7 Schengen \u00b7 D8 Visa',
    score: 87.4,
    featured: true,
    move: 'same',
    moveLabel: '\u2014 Same',
    note: 'Holds #1 on the strength of its 5-year citizenship pathway and the retained advantages of the revised IFICI regime, despite a tightening income threshold.',
  },
  {
    rank: 2,
    name: 'Spain',
    region: 'Europe \u00b7 EU \u00b7 Schengen \u00b7 DNV',
    score: 84.1,
    move: 'up',
    moveLabel: '\u25b2 Up 2',
    note: 'Climbs two places after the consolidation of its application process and confirmed 15% tax rate for the first six years.',
  },
  {
    rank: 3,
    name: 'United Arab Emirates',
    region: 'Middle East \u00b7 GCC \u00b7 Virtual Working Programme',
    score: 81.9,
    move: 'same',
    moveLabel: '\u2014 Same',
    note: 'The tax story writes itself at 0%. Held back from #1 only by absent citizenship pathway and single-year renewability.',
  },
  {
    rank: 4,
    name: 'Estonia',
    region: 'Europe \u00b7 EU \u00b7 Schengen \u00b7 DNV',
    score: 79.3,
    move: 'down',
    moveLabel: '\u25bc Down 1',
    note: 'The original. Exceptional digital infrastructure and clear processes, offset only by a harsh winter and limited family infrastructure.',
  },
  {
    rank: 5,
    name: 'Italy',
    region: 'Europe \u00b7 EU \u00b7 Schengen \u00b7 DNV',
    score: 77.6,
    move: 'new',
    moveLabel: '\u2605 New entry',
    note: 'A strong debut in the Top 10 following the maturation of Italy\u2019s 2024 DNV legislation and confirmed tax arrangements for qualifying workers.',
  },
  {
    rank: 6,
    name: 'Croatia',
    region: 'Europe \u00b7 EU \u00b7 DNV Residence Permit',
    score: 76.2,
    move: 'up',
    moveLabel: '\u25b2 Up 1',
    note: 'The best value proposition in Europe \u2014 a \u20ac2,540 threshold paired with genuine tax exemption for the visa year.',
  },
  {
    rank: 7,
    name: 'Japan',
    region: 'Asia \u00b7 DNV (6-month)',
    score: 74.0,
    move: 'same',
    moveLabel: '\u2014 Same',
    note: 'High-quality-of-life score offsets a stringent \u00a510M income floor and the absence of a renewal path \u2014 for now.',
  },
  {
    rank: 8,
    name: 'Mauritius',
    region: 'Indian Ocean \u00b7 Premium Travel Visa',
    score: 72.8,
    move: 'up',
    moveLabel: '\u25b2 Up 3',
    note: 'The most accessible programme in the Top 10 at $1,500/month, combined with genuine tax efficiency and stable governance.',
  },
  {
    rank: 9,
    name: 'Costa Rica',
    region: 'Americas \u00b7 LatAm \u00b7 Rentista / DNV',
    score: 71.5,
    move: 'down',
    moveLabel: '\u25bc Down 2',
    note: 'A stable LatAm proposition with strong family infrastructure. Drops slightly as competitors mature faster.',
  },
  {
    rank: 10,
    name: 'Barbados',
    region: 'Caribbean \u00b7 Welcome Stamp',
    score: 70.1,
    move: 'same',
    moveLabel: '\u2014 Same',
    note: 'The original Welcome Stamp retains relevance for high-earners seeking the Caribbean on pre-established legal footing.',
  },
];

export const DIMENSIONS = [
  {
    n: '01',
    name: 'Accessibility',
    weight: '15%',
    what: 'Income threshold as a multiple of median global remote worker income. Document complexity. Historical rejection rate by consulate.',
    source: 'Government visa requirements \u00b7 Nomad Compass internal casework',
  },
  {
    n: '02',
    name: 'Processing Speed',
    weight: '10%',
    what: 'Median real-world days from application submission to visa issued. Measures observed performance rather than advertised timelines.',
    source: 'Nomad Compass casework \u00b7 Consulate Experience Log',
  },
  {
    n: '03',
    name: 'Total Cost of Moving',
    weight: '15%',
    what: 'All-in first-year cost including application, translations, apostilles, insurance, residency card, plus twelve months of cost of living for a single remote worker earning US$80,000.',
    source: 'Government fees \u00b7 Numbeo cost-of-living index \u00b7 Nomad Compass cost playbook',
  },
  {
    n: '04',
    name: 'Tax Friendliness',
    weight: '15%',
    what: 'Effective tax rate for an US$80,000 remote worker under any applicable special regime. Accounts for NHR/IFICI, UAE 0%, Croatian exemption, and double taxation treaties.',
    source: 'National tax codes \u00b7 Bilateral tax treaties \u00b7 PWC tax summaries',
  },
  {
    n: '05',
    name: 'Family Viability',
    weight: '10%',
    what: 'Spouse and dependent visa allowance. Spouse work rights. International school availability and cost. Family cost loading factor.',
    source: 'Government immigration rules \u00b7 ISC international schools database \u00b7 WHO family health index',
  },
  {
    n: '06',
    name: 'Path to Permanence',
    weight: '10%',
    what: 'Years to permanent residency from initial visa. Years to citizenship eligibility. Bonus scoring where the digital nomad visa counts toward both paths.',
    source: 'National immigration law \u00b7 Henley & Partners citizenship review',
  },
  {
    n: '07',
    name: 'Visa Stability',
    weight: '10%',
    what: 'Age of the programme. Government political stability. Legislative risk \u2014 whether the programme has been revised, threatened, or partially cancelled. The hidden fear made visible.',
    source: 'Programme legislative history \u00b7 Economist Intelligence Unit political risk',
  },
  {
    n: '08',
    name: 'Quality of Life',
    weight: '15%',
    what: 'Composite of healthcare (WHO), safety (Numbeo), English proficiency (EF EPI), internet speed (Speedtest), and climate rating.',
    source: 'WHO \u00b7 Numbeo \u00b7 EF English Proficiency Index \u00b7 Ookla Speedtest Global Index',
  },
];

export const LIMITATIONS = [
  {
    title: 'Culture fit and community warmth',
    body: 'Whether you will make friends in Lisbon or feel isolated in Tallinn is not something a spreadsheet can answer. We exclude all subjective cultural measures from the scoring. What feels like home is yours to decide.',
  },
  {
    title: 'Weather preference',
    body: 'Climate is part of our composite Quality of Life score, but we do not weight it against personal preference. A nomad who thrives in Nordic winters and a nomad who needs tropical heat will see different truths in our rankings.',
  },
  {
    title: 'LGBTQ+ and minority-specific realities',
    body: 'We currently do not score countries on LGBTQ+ legal protection, women\u2019s safety, or minority-specific considerations. A future edition will add a separate Rights & Protections dimension; for now, we note this as a meaningful absence.',
  },
  {
    title: 'Application experience at specific consulates',
    body: 'Two applicants from the same country filing at different consulates may have radically different experiences. Our Consulate Experience Log addresses this; the Index does not.',
  },
  {
    title: 'Currency and macro risk',
    body: 'The Argentine peso and the euro are different propositions. We do not currently weight currency risk into the cost dimension; we are exploring how to do this credibly for future issues.',
  },
];

export const CHANGELOG = [
  {
    date: 'November 2025',
    title: 'Portugal IFICI regime confirmed for remote workers.',
    body: 'After eighteen months of ambiguity following the end of NHR, the replacement regime\u2019s scope was finalised. Portugal\u2019s Tax Friendliness score recovered 8 points.',
  },
  {
    date: 'October 2025',
    title: 'Spain DNV application process streamlined.',
    body: 'Consolidated submission via UGE reduced median processing time by 21 days. Spain\u2019s Accessibility and Speed scores both improved.',
  },
  {
    date: 'September 2025',
    title: 'Indonesia KITAS B1 clarified but remains restrictive.',
    body: 'Revised guidance confirmed the programme as functionally a business visa with nomad-adjacent provisions. Remains outside Top 10 due to Accessibility and Permanence constraints.',
  },
  {
    date: 'August 2025',
    title: 'Mauritius Premium Travel Visa renewal confirmed through 2028.',
    body: 'Political stability score recovered to pre-2023 levels; overall ranking advanced three positions.',
  },
  {
    date: 'July 2025',
    title: 'Italy DNV operational data reached statistical significance.',
    body: 'Sufficient application volume accumulated to score Italy on real-world Processing Speed for the first time. Entered Top 10.',
  },
];
